import * as authConsts from './constants';

/**
 * LOGIN
 */

export function login(attributes) {
  return {
    type: authConsts.LOGIN_REQUEST,
    isFetching: true,
    isAuthenticated: false,
    verifySuccess: false,
    user: {},
    attributes,
  };
}

export function loginError(error) {
  return {
    type: authConsts.LOGIN_FAILURE,
    isFetching: false,
    isAuthenticated: false,
    loginErrorMessage: error,
  };
}

export function loginSuccess() {
  return {
    type: authConsts.LOGIN_SUCCESS,
    isFetching: false,
    isAuthenticated: true,
    loginErrorMessage: null,
  };
}

/**
 * SIGNUP
 */

export function signup(attributes) {
  return {
    type: authConsts.SIGNUP_REQUEST,
    isFetching: true,
    isAuthenticated: false,
    signupSuccess: false,
    user: {},
    attributes,
  };
}

export function signupError(error) {
  return {
    type: authConsts.SIGNUP_FAILURE,
    isFetching: false,
    isAuthenticated: false,
    signupSuccess: false,
    signupErrorMessage: error,
  };
}

export function signupSuccess() {
  return {
    type: authConsts.SIGNUP_SUCCESS,
    isFetching: false,
    isAuthenticated: false,
    signupSuccess: true,
    signupErrorMessage: null,
  };
}

export function signupReset() {
  return {
    type: authConsts.SIGNUP_SUCCESS,
    isFetching: false,
    isAuthenticated: false,
    signupSuccess: false,
  };
}

/**
 * SIGNUP CONFIRMATION
 */

export function signupConfirmation(code) {
  return {
    type: authConsts.SIGNUP_CONFIRMATION_REQUEST,
    isFetching: true,
    signupConfirmationSuccess: false,
    isAuthenticated: false,
    user: {},
    code,
  };
}

export function signupConfirmationError(error) {
  return {
    type: authConsts.SIGNUP_CONFIRMATION_FAILURE,
    isFetching: false,
    signupConfirmationSuccess: false,
    signupConfirmationErrorMessage: error,
    isAuthenticated: false,
  };
}

export function signupConfirmationSuccess() {
  return {
    type: authConsts.SIGNUP_CONFIRMATION_SUCCESS,
    isFetching: false,
    signupConfirmationSuccess: true,
    signupConfirmationErrorMessage: null,
    isAuthenticated: false,
  };
}

/**
 * FORGOT
 */

export function forgot(attributes) {
  return {
    type: authConsts.FORGOT_REQUEST,
    isFetching: true,
    forgotSuccess: false,
    attributes,
  };
}

export function forgotError(error) {
  return {
    type: authConsts.FORGOT_FAILURE,
    isFetching: false,
    forgotSuccess: false,
    forgotErrorMessage: error,
  };
}

export function forgotSuccess() {
  return {
    type: authConsts.FORGOT_SUCCESS,
    isFetching: false,
    forgotErrorMessage: null,
    forgotSuccess: true,
  };
}

export function forgotReset() {
  return {
    type: authConsts.FORGOT_SUCCESS,
    isFetching: false,
    forgotSuccess: false,
  };
}

/**
 * FORGOT CONFIRMATION
 */

export function forgotConfirmation(code) {
  return {
    type: authConsts.FORGOT_CONFIRMATION_REQUEST,
    isFetching: true,
    forgotConfirmationSuccess: false,
    isAuthenticated: false,
    user: {},
    code,
  };
}

export function forgotConfirmationError(error) {
  return {
    type: authConsts.FORGOT_CONFIRMATION_FAILURE,
    isFetching: false,
    forgotConfirmationSuccess: false,
    forgotConfirmationErrorMessage: error,
    isAuthenticated: false,
  };
}

export function forgotConfirmationSuccess() {
  return {
    type: authConsts.FORGOT_CONFIRMATION_SUCCESS,
    isFetching: false,
    forgotConfirmationSuccess: true,
    forgotConfirmationErrorMessage: null,
    isAuthenticated: false,
  };
}

/**
 * LOGOUT
 */

export function logout() {
  return {
    type: authConsts.LOGOUT_REQUEST,
    isFetching: true,
    isAuthenticated: false,
    user: {},
  };
}

export function logoutSuccess() {
  return {
    type: authConsts.LOGOUT_SUCCESS,
    isFetching: false,
    isAuthenticated: false,
    user: {},
  };
}

/**
 *  VERIFY
 */

export function verify() {
  return {
    type: authConsts.VERIFY_REQUEST,
    isFetching: true,
    isAuthenticated: false,
    user: {},
  };
}

export function verifyError() {
  return {
    type: authConsts.VERIFY_FAILURE,
    isFetching: false,
    isAuthenticated: false,
  };
}

export function verifySuccess(user) {
  return {
    type: authConsts.VERIFY_SUCCESS,
    isFetching: false,
    isAuthenticated: true,
    verifySuccess: true,
    user,
  };
}



// WEBPACK FOOTER //
// ./src/containers/Auth/actions.js